import React from "react";
import { directToPage } from "lib/redirect-helpers";
import { useQuery } from "@apollo/client";
import { getUrl } from "@outplayed/riot-assets";
import { GET_USER_STATE } from "api/graphql/queries";
import CHECK_YIR_STATUS from "components/Pages/PerformanceReview/queries/checkYearInReviewStatus";

// TODO add polling or refetching to check if the YIR Status has changed
const PerformanceAnalysisLoading = (props) => {
  const minutesRemaining = 24;
  const directToYIR = directToPage("performanceAnalysis");
  const { data } = useQuery(GET_USER_STATE, { fetchPolicy: "network-only" });
  const { data: yirStatus } = useQuery(CHECK_YIR_STATUS, {
    variables: {
      regionId: data ? data.getState.lolSettings.summoners[0].regionId : "na1",
      summonerName: data ? data.getState.lolSettings.summoners[0].summonerName : "",
      season: 14,
    },
    fetchPolicy: "network-only",
    skip: !data,
  });
  const isYIRDataReady = yirStatus && yirStatus.summonerReviewStatus.status === "ready";

  if (isYIRDataReady) {
    directToYIR();
  }

  return (
    <div>
      <div className="performance-container loading-page">
        <div className="large-header">GENERATING YOUR YEAR IN REVIEW ...</div>
        <div className="normal-text">Estimated wait time:</div>
        <div className="time-remaining">
          <div className="small-header">{"< " + minutesRemaining} hours</div>
        </div>
        <div className="normal-text">Check back later!</div>
        <img className="loading-image" src={getUrl("lol/performance_analysis/images/YiR-loading.png")} />
      </div>
    </div>
  );
};

export default PerformanceAnalysisLoading;
